export default __webpack_public_path__ + "static/media/currancy.6ff6236c.png";